import { AppState } from 'Store'

const getUnpaidActs = (state: AppState) => state.actUnpaid.data

const getUnpaidActsRequestParams = (state: AppState) => state.actUnpaid.requestParams

const getOnPartnerSigningSingleCount = (state: AppState) =>
	state.actUnpaid.counter.on_partner_signing_single
const getOnPartnerSigningSeveralCount = (state: AppState) =>
	state.actUnpaid.counter.on_partner_signing_several
const getAmountMore5KCount = (state: AppState) => state.actUnpaid.counter.amount_more_5k

export const ActsUnpaidSelector = {
	getUnpaidActs,
	getUnpaidActsRequestParams,
	getOnPartnerSigningSingleCount,
	getOnPartnerSigningSeveralCount,
	getAmountMore5KCount,
}
